import React from 'react'
import ReactDOM from 'react-dom'
import { App } from './app'

const element = document.querySelector(
  '#visualizer-CA69E31E-01D2-4626-ACF9-A10A3AD8865E'
)

if (!element) {
  throw new Error('Missing product elements')
}

ReactDOM.render(<App />, element)
